import type {
  SupportMessageItem,
  SupportMessageStatus,
  SupportMessagesListResponse,
  UpdateSupportMessageRequest,
} from '@shared/types';
import { api } from './api';

function toQuery(params: Record<string, unknown>): string {
  const parts: string[] = [];
  for (const [k, v] of Object.entries(params)) {
    if (v === undefined || v === null || v === '') continue;
    parts.push(`${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`);
  }
  return parts.length > 0 ? `?${parts.join('&')}` : '';
}

export interface ListSupportMessagesParams {
  status?: SupportMessageStatus;
  page?: number;
  pageSize?: number;
}

export async function listSupportMessages(
  params: ListSupportMessagesParams = {}
): Promise<SupportMessagesListResponse> {
  const qs = toQuery({
    status: params.status,
    page: params.page ?? 1,
    pageSize: params.pageSize ?? 25,
  });
  return api<SupportMessagesListResponse>(`/admin/support/messages${qs}`);
}

export async function getSupportMessage(id: string): Promise<SupportMessageItem> {
  return api<SupportMessageItem>(`/admin/support/messages/${id}`);
}

export async function updateSupportMessage(
  id: string,
  body: UpdateSupportMessageRequest
): Promise<SupportMessageItem> {
  return api<SupportMessageItem>(`/admin/support/messages/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}
